module.exports = __webpack_public_path__ + "img/logo-m2n.a9416d9a.svg";